import ReactDOM from "react-dom";
import { Button } from "../Button/Button";
import { DialogProps } from "./types";

const Dialog: React.FC<DialogProps> = (props: DialogProps) => {
  const {
    open,
    title = "",
    message = "",
    confirmText = "",
    cancelText = "",
    onConfirm,
    onCancel,
  } = props;

  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <div className="fixed inset-0 bg-gray-500/50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-80 animate-fadeIn">
          <h2 className="text-lg font-semibold mb-3 text-gray-800">{title}</h2>
          <p className="text-sm text-gray-600 mb-6">{message}</p>
          <div className="flex justify-end gap-3">
            <Button onClick={onCancel} variant="outlined">
              {cancelText}
            </Button>
            <Button onClick={onConfirm} variant="primary">
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default Dialog;
